import { AlertBox, AlertTitle } from "../FillErrorAlert/styles";
import emojiNeutral from "../../../assets/image/neutralEmojiRed.svg";
// import { Emoji, CloseButton, AlertContent } from "../alertStyles";
import * as S from './styles';

export const ErrorBaseCad = ({ handleClose, message = "", open = false }) => {
  if (open) {
    return (
      <S.AlertBox>
        <S.CloseButton onClick={handleClose}>x</S.CloseButton>
        <S.Emoji src={emojiNeutral} alt="Emoji de rosto neutro" />
        <S.AlertTitle>Ops! Ocorreu um erro ao fazer seu upload.</S.AlertTitle>
        {message && <S.AlertMessage>{message}</S.AlertMessage>}
      </S.AlertBox>
    );
  }
};
